export async function fetchRegistrationState(registrationId: string) {
  return await $fetch
    .raw(`/customer/registration/${registrationId}`, {
      baseURL: useRuntimeConfig().public.apiBaseURL,
      method: 'GET',
    })
    .catch((error) => {
      return error.data
    })
}
